import React, { forwardRef } from 'react';

type OwnProps = React.PropsWithoutRef<React.SVGProps<SVGSVGElement>>;

const VehicleFront = forwardRef<SVGSVGElement, OwnProps>((props, ref) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="30"
    height="25"
    viewBox="0 0 30 25"
    fill="none"
    ref={ref}
    {...props}
  >
    <path
      id="Vector"
      d="M6.35994 9.00012H23.6399C26.5877 9.00012 28.9999 11.4124 28.9999 14.3601V17.0001V20.0001H0.999939V17.0001V14.3601C0.999939 11.4124 3.41222 9.00012 6.35994 9.00012Z"
      stroke="#00619E"
      strokeWidth="2"
    />
    <path
      id="Vector_2"
      d="M11.1199 1.00012H18.8799C22.244 1.00012 24.9999 3.75876 24.9999 7.15012V8.03012V9.00012H4.99994V8.03012V7.15012C4.99994 3.75876 7.75587 1.00012 11.1199 1.00012Z"
      stroke="#00619E"
      strokeWidth="2"
    />
    <path
      id="Vector_3"
      d="M29.9999 7.58012C29.9999 8.21012 29.6299 8.78012 29.0499 9.03012L27.3199 9.79012C25.7999 10.4501 23.9999 9.47012 23.9999 8.00012C23.9999 6.90012 25.0199 6.00012 26.2999 6.00012H28.4199C29.2899 6.00012 29.9999 6.71012 29.9999 7.58012Z"
      fill="#00619E"
    />
    <path
      id="Vector_4"
      d="M-6.10352e-05 7.58012C-6.10352e-05 8.21012 0.369939 8.78012 0.949939 9.03012L2.67994 9.79012C4.19994 10.4501 5.99994 9.47012 5.99994 8.00012C5.99994 6.90012 4.97994 6.00012 3.69994 6.00012H1.57994C0.709939 6.00012 -6.10352e-05 6.71012 -6.10352e-05 7.58012Z"
      fill="#00619E"
    />
    <path
      id="Vector_5"
      d="M20.9999 21.0001C20.9999 23.2001 22.7999 25.0001 24.9999 25.0001H25.9999C28.1999 25.0001 29.9999 23.2001 29.9999 21.0001H20.9999Z"
      fill="#00619E"
    />
    <path
      id="Vector_6"
      d="M-6.10352e-05 21.0001C-6.10352e-05 23.2001 1.79994 25.0001 3.99994 25.0001H4.99994C7.19994 25.0001 8.99994 23.2001 8.99994 21.0001H-6.10352e-05Z"
      fill="#00619E"
    />
    <path
      id="Vector_7"
      d="M10.4999 15.0001H19.4999"
      stroke="#00619E"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      id="Vector_8"
      d="M23.9999 17.0001C25.1045 17.0001 25.9999 16.1047 25.9999 15.0001C25.9999 13.8956 25.1045 13.0001 23.9999 13.0001C22.8954 13.0001 21.9999 13.8956 21.9999 15.0001C21.9999 16.1047 22.8954 17.0001 23.9999 17.0001Z"
      fill="#00AED9"
    />
    <path
      id="Vector_9"
      d="M5.99994 17.0001C7.10451 17.0001 7.99994 16.1047 7.99994 15.0001C7.99994 13.8956 7.10451 13.0001 5.99994 13.0001C4.89537 13.0001 3.99994 13.8956 3.99994 15.0001C3.99994 16.1047 4.89537 17.0001 5.99994 17.0001Z"
      fill="#00AED9"
    />
  </svg>
));

export default VehicleFront;
